@if (accountRequests.length) {
<div [ngStyle]="widgetStyle" [style.flex-direction]="listDirection" class="d-flex">
  @for (request of accountRequests; track request.id) {
  <!-- <div This is for sumsub without sumsub the click needs to be disabled
    class="pointer-events-none"
    (click)="onRequestClick(request.id)"
    [innerHTML]="createItemTemplate(request) | safeHtml"
  ></div> -->
  <div
    class="pointer-events-none"
    [innerHTML]="createItemTemplate(request) | safeHtml"
  ></div>
  }
</div>
}
